import accountIcon from '../assets/icons/account.svg'
import companyIcon from '../assets/icons/company.svg'
import amusementIcon from '../assets/icons/amusement.svg'
import hearthIcon from '../assets/icons/hearth-black.svg'

const companyTypeEnum = [
  {
    label: 'Niet officeel / informeel / overig',
    value: 'non-official',
    icon: accountIcon,
  },
  {
    label: 'Commercieel (BV, NV, ZZP, VOF, ...)',
    value: 'commercial',
    icon: companyIcon,
  },
  {
    label: 'Publiek / overheid',
    value: 'public',
    icon: amusementIcon,
  },
  {
    label: 'Non profit',
    value: 'non-profit',
    icon: hearthIcon,
  },
];

export default companyTypeEnum